import React from 'react';

const MapIcon = () => {
	return (
		<svg
			data-testid='map'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M20.0813 15.975L14.9906 12.8437C14.903 12.7874 14.8035 12.7521 14.7 12.7406L12.5531 12.45C12.393 12.427 12.2297 12.4578 12.0889 12.5375C11.9481 12.6172 11.8377 12.7414 11.775 12.8906L10.4906 15.7687C10.4303 15.9026 10.4105 16.0513 10.4338 16.1963C10.4572 16.3412 10.5226 16.4762 10.6219 16.5844L12.3844 18.4875C12.4641 18.5751 12.5224 18.6798 12.555 18.7937C12.5875 18.9075 12.5933 19.0273 12.5719 19.1437L12.2063 21'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.09373 5.21252L5.24998 7.20002C5.17649 7.37647 5.17313 7.57432 5.2406 7.75315L6.31873 10.6219C6.36086 10.7415 6.43299 10.8482 6.52819 10.9319C6.6234 11.0157 6.7385 11.0735 6.86248 11.1L8.86873 11.5313C8.98008 11.5538 9.08466 11.602 9.17416 11.6719C9.26366 11.7419 9.33563 11.8318 9.38435 11.9344L9.7406 12.675C9.8039 12.8002 9.90026 12.9058 10.0192 12.9801C10.1382 13.0545 10.2753 13.0949 10.4156 13.0969H11.6812'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.2969 3.29065L15.1688 4.86565C15.2493 5.01372 15.2782 5.18437 15.2511 5.35071C15.2239 5.51704 15.1422 5.66962 15.0188 5.7844L12.4969 8.06253C12.4547 8.10284 12.4074 8.1375 12.3563 8.16565L11.2032 8.80315C11.0932 8.86147 10.9713 8.89356 10.8469 8.8969H8.84065C8.69285 8.89765 8.54849 8.94152 8.42526 9.02311C8.30203 9.10471 8.20529 9.2205 8.1469 9.35628L7.36877 11.2032'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default MapIcon;
